import {createSlice} from '@reduxjs/toolkit';

import storeSliceNames from '../../consts/storeSliceNames';

const initialState = {
    messages: [],
    unreadMessageCount: 0,
    lastReceivedMessageId: undefined,
};

const messageSlice = createSlice({
    name: storeSliceNames.message,
    initialState,
    reducers: {
        setMessages(state, action) {
            return {
                ...state,
                messages: action.payload,
            };
        },
        expandMessageList(state, action) {
            return {
                ...state,
                messages: [...state.messages, ...action.payload],
            };
        },
        readMessage(state, action) {
            const message = state.messages.find((message) => message.messageId === action.payload);

            if (message) {
                message.isRead = true;
            }
        },
        deleteMessage(state, action) {
            const message = state.messages.find((message) => message.messageId === action.payload);

            if (message) {
                message.isDeleted = true;
            }
        },
        updateMessageById(state, action) {
            const {messageId, isRead, isDeleted} = action.payload;
            const message = state.messages.find((message) => message.messageId === messageId);

            if (message) {
                if (isRead !== undefined) message.isRead = isRead;
                if (isDeleted !== undefined) message.isDeleted = isDeleted;
            }
        },
        setUnreadMessageCount(state, action) {
            return {
                ...state,
                unreadMessageCount: action.payload,
            };
        },
        setLastReceivedMessageId(state, action) {
            return {
                ...state,
                lastReceivedMessageId: action.payload,
            };
        },
    },
});

export const setMessages = (messages) => messageSlice.actions.setMessages(messages);

export const expandMessageList = (messages) => messageSlice.actions.expandMessageList(messages);

export const readMessage = (messageId) => messageSlice.actions.readMessage(messageId);

export const deleteMessage = (messageId) => messageSlice.actions.deleteMessage(messageId);

export const setUnreadMessageCount = (messageCount) => messageSlice.actions.setUnreadMessageCount(messageCount);

export const updateMessageById = ({messageId, isRead, isDeleted}) =>
    messageSlice.actions.updateMessageById({messageId, isRead, isDeleted});

export const setLastReceivedMessageId = (messageId) => messageSlice.actions.setLastReceivedMessageId(messageId);

export default messageSlice.reducer;
